<template>
    <div id="landing">

        <div>

            <Prizes></Prizes>
            <Form></Form>
            <Winners></Winners>

            <div id="characters">
                <img src="../assets/img/Bobo.png" alt="" class="left">
                <img src="../assets/img/Costel.png" alt="" class="right">
            </div>

        </div>

<!--        <Footer></Footer>-->

    </div>
</template>

<script>
    import Prizes from "@/components/Prizes";
    import Form from "@/components/Form";
    import Winners from "@/components/Winners";
    // import Footer from "@/components/Footer";

    export default {
        name: "Landing",
        components: {
            // Footer,
            Prizes,
            Form,
            Winners
        },
        data() {
            return {
                opts: {
                    start: 0,
                    dir: 'v',
                    loop: false,
                    duration: 100,
                    beforeChange: function (prev, next) {
                        console.log('before', prev, next)
                    },
                    afterChange: function (prev, next) {
                        console.log('after', prev, next)
                    }
                }
            }
        },
    }
</script>

<style scoped>
    #landing {
        background-image: url("../assets/img/bg_ncp.jpg");
        background-repeat: no-repeat;
        background-attachment: fixed;
        background-size: cover;
        overflow: hidden;
    }


    #landing #characters {
        position: relative;
    }

    #landing #characters img {
        position: fixed;
        max-height: 80%;
        max-width: 45%;
    }

    #landing #characters img.left {
        bottom: -10%;
        z-index: 1024;
        left: 2%;
    }

    #landing #characters img.right {
        bottom: -14%;
        z-index: 1024;
        right: 2%;
    }

    @media (max-width: 1500px) {
        #landing #characters img.left {
            left: -5%;
            bottom: -5%;
        }
        #landing #characters img.right {
            right: -5%;
            bottom: -7%;
        }
    }
    @media (max-width: 1250px) {
        #landing #characters img {
            max-height: 60%;
            max-width: 45%;
        }
        #landing #characters img.left {
            bottom: -1%;
        }
        #landing #characters img.right {
            bottom: -1%;
        }
    }
    @media (max-width: 1100px) {
        #landing #characters img.left {
            left: -12%;
            bottom: -5%;
        }
        #landing #characters img.right {
            right: -12%;
            bottom: -7%;
        }
    }

    @media (max-width: 991px) {
        #landing #characters img {
            position: relative;
            margin-top: -10%;
        }
        #landing #characters img.left, #landing #characters img.right{
            margin-bottom: -10%;
            left: 2%;
            right: 2%;
        }
    }

    @media (max-width: 768px) {
        #landing #characters img {
            margin-top: -5%;
        }
    }

</style>
